"use client";

import NextError from "next/error";
import { useEffect } from "react";
export default function GlobalError({
  error
}) {
  return <html data-sentry-component="GlobalError" data-sentry-source-file="global-error.jsx">
            <body>
                {/* This is the default Next.js error component. */}
                <NextError data-sentry-element="NextError" data-sentry-source-file="global-error.jsx" />
            </body>
        </html>;
}